import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './ui/Header';
import Footer from '../pages/homepage/components/Footer';

/**
 * Single layout for the app. Header and Footer render once;
 * only the Outlet (page content) changes on navigation — proper SPA behavior.
 */
const Layout = () => {
  return (
    <div className="min-h-screen bg-background transition-colors duration-300 flex flex-col">
      <Header />
      <main className="pt-16 flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
